export default __webpack_public_path__ + "static/media/Paytm.fedd5c58.svg";